var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 135,
    viewBox: "0 0 128 135",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.2996 109.7C98.2996 109.7 121 87.0001 121 58.9001C121 30.8001 98.1996 8.1001 70.2996 8.1001C42.2996 8.1001 19.5996 30.8001 19.5996 58.9001C19.5996 87.0001 42.2996 109.7 70.2996 109.7Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 25.5999C119.964 25.5999 121.8 23.7643 121.8 21.4999C121.8 19.2355 119.964 17.3999 117.7 17.3999C115.435 17.3999 113.6 19.2355 113.6 21.4999C113.6 23.7643 115.435 25.5999 117.7 25.5999Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.7 9.6C125.247 9.6 126.5 8.3464 126.5 6.8C126.5 5.2536 125.247 4 123.7 4C122.154 4 120.9 5.2536 120.9 6.8C120.9 8.3464 122.154 9.6 123.7 9.6Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 25.4999C23.8464 25.4999 25.1 24.2463 25.1 22.6999C25.1 21.1535 23.8464 19.8999 22.3 19.8999C20.7536 19.8999 19.5 21.1535 19.5 22.6999C19.5 24.2463 20.7536 25.4999 22.3 25.4999Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 79.5001C8.07188 79.5001 10.4 77.172 10.4 74.3001C10.4 71.4282 8.07188 69.1001 5.2 69.1001C2.32812 69.1001 0 71.4282 0 74.3001C0 77.172 2.32812 79.5001 5.2 79.5001Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34725_41270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.8 33.5L105.6 97.9C105.6 100.1 103.8 101.8 101.6 101.8H38.7998C36.5998 101.8 34.7998 100 34.7998 97.9V15.1C34.7998 12.9 36.5998 11.2 38.7998 11.2H84.2998L104.8 33.5Z",
    fill: "url(#paint0_linear_34725_41270)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4002 88.9H63.1002C62.6002 88.9 62.2002 88.4 62.2002 87.8C62.2002 87.2 62.6002 86.7 63.1002 86.7H65.4002C65.9002 86.7 66.3002 87.2 66.3002 87.8C66.3002 88.5 65.9002 88.9 65.4002 88.9Z",
    fill: "#CED7E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3996 88.9H44.9996C44.4996 88.9 44.0996 88.4 44.0996 87.8C44.0996 87.2 44.4996 86.7 44.9996 86.7H58.3996C58.8996 86.7 59.2996 87.2 59.2996 87.8C59.2996 88.5 58.8996 88.9 58.3996 88.9Z",
    fill: "#D5DDEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4996 24.7001H45.3996C44.6996 24.7001 44.0996 24.1001 44.0996 23.4001C44.0996 22.7001 44.6996 22.1001 45.3996 22.1001H75.4996C76.1996 22.1001 76.7996 22.7001 76.7996 23.4001C76.7996 24.1001 76.1996 24.7001 75.4996 24.7001Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9996 31.9H45.3996C44.6996 31.9 44.0996 31.3001 44.0996 30.6C44.0996 29.9 44.6996 29.3 45.3996 29.3H56.8996C57.5996 29.3 58.1996 29.9 58.1996 30.6C58.1996 31.3001 57.5996 31.9 56.9996 31.9Z",
    fill: "#D5DDEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2998 11.2V29C84.2998 31.5 86.4998 33.5 88.9998 33.5H104.8",
    fill: "#D5DDEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.6 103.3C108.6 103.3 107.6 102.9 106.8 102L90.1 85.3L89.5 85.6999C84.1 89.6999 77.8 91.8 71.4 91.8C63.7 91.8 56 88.7 50.3 83.3C44.3 77.6 41 69.8999 41 61.5C41 44.7999 54.6 31.2 71.3 31.2C82.7 31.2 92.7 37.2 98.1 47.4C103.4 57.5 102.7 69.3 96.2 78.8L95.8 79.4L112.6 96.2C114.3 97.8999 113.9 99.6 113.6 100.5C112.8 102.1 111.2 103.3 109.6 103.3ZM71.3 39.5C59.1 39.5 49.3 49.4 49.3 61.5C49.3 75.2999 60.6 83.5999 71.6 83.5999C78.3 83.5999 84.4 80.5999 88.7 75.1999C94 68.5999 94.9 59.7 91.2 52C87.4 44.3 79.8 39.5 71.3 39.5Z",
    fill: "#989FB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8004 65.1C63.1004 65.1 64.2004 64.0001 64.2004 62.7001C64.2004 61.4001 63.1004 60.3 61.8004 60.3C60.5004 60.3 59.4004 61.4001 59.4004 62.7001C59.4004 64.0001 60.5004 65.1 61.8004 65.1Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1998 65.1C81.4998 65.1 82.5998 64.0001 82.5998 62.7001C82.5998 61.4001 81.4998 60.3 80.1998 60.3C78.8998 60.3 77.7998 61.4001 77.7998 62.7001C77.7998 64.1001 78.8998 65.1 80.1998 65.1Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7062 54.7598L56.4268 57.6104L57.1394 58.9302L62.4188 56.0796L61.7062 54.7598Z",
    fill: "#989FB0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8736 54.722L79.1611 56.042L84.4411 58.892L85.1536 57.572L79.8736 54.722Z",
    fill: "#989FB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0002 70.7C72.5466 70.7 73.8002 69.7598 73.8002 68.6C73.8002 67.4402 72.5466 66.5 71.0002 66.5C69.4538 66.5 68.2002 67.4402 68.2002 68.6C68.2002 69.7598 69.4538 70.7 71.0002 70.7Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34725_41270",
    x: 12.7998,
    y: 0.199951,
    width: 114.8,
    height: 134.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34725_41270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34725_41270",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34725_41270",
    x1: 70.1767,
    y1: 9.10429,
    x2: 70.1767,
    y2: 102.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.e908cd40.svg";
export { ForwardRef as ReactComponent };